import { render, staticRenderFns } from "./escapeArea.vue?vue&type=template&id=5ed52b26&scoped=true&"
import script from "./escapeArea.vue?vue&type=script&lang=js&"
export * from "./escapeArea.vue?vue&type=script&lang=js&"
import style0 from "./escapeArea.vue?vue&type=style&index=0&id=5ed52b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed52b26",
  null
  
)

export default component.exports